export default {"src":"/uk/_next/static/media/spot-withdraw.7d80d7e6.svg","height":60,"width":60,"blurWidth":0,"blurHeight":0};